export enum UserAuthType {
    WhutsFree, Facebook, Google, Apple
}
